import GridIcon from './component'

export default GridIcon
